let version = (new Date()).getTime();

const scripts = this.document?.getElementsByTagName('script') || [];
for (var i = 0; i < scripts.length; i++) {
	var m = scripts[i].src.match(/\?v=([0-9]+)/);
	if (m) {
		version = m[1];
		console.log('Version ID found:', version);
		break;
	}
}

module.exports = version;
